import SecondaryLogoCompany from './container'
export { SecondaryLogoCompany }
export default SecondaryLogoCompany